import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Table, TableHead, TableRow, TableCell, TableBody, Collapse } from '@material-ui/core';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { timeFormat, toMoney } from '../../../common/utils';

const Root = styled(Box)({
    width: '100%',
    overflowX: 'auto',
    '& .tableHead': {
        paddingLeft: '40px',
        height: '60px',
        color: '#9B9B9B',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .iconExpand': {
        margin: '0 10px',
        transform: "rotate(0deg)",
        color: '#9B9B9B',
    },
    '& .iconClose': {
        margin: '0 10px',
        transform: "rotate(-90deg)",
        color: '#9B9B9B',
    },
    '& .extend': {
        backgroundColor: '#fff',
    },
    '& .expandBtn': {
        cursor: 'pointer',
        height: '60px',
        color: '#005F9B',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .closeBtn': {
        cursor: 'pointer',
        height: '60px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .table': {
        minWidth: '650px',
    },
    '& .w290': {
        width: '290px',
    },
    '& .noTeams': {
        height: '60px',
        color: '#9B9B9B',
        borderBottom: '1px solid #D8D8D8',
    },
    '& .hCell': {
        padding: '0 16px',
        color: '#FEFCFF',
        backgroundColor: '#CDCBD0',
    },
    '& .bCell': {
        backgroundColor: '#F5FBFF',
    },
    '& .w-100': {
        width: '100px',
    },
    '& .max-h-100': {
        overflow: 'auto',
        maxHeight: '315px',
    },
})

class RevenueTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            revenuesData: [],
        }
        this.handleClickItem = this.handleClickItem.bind(this);
    }
    render() {
        const {
            revenuesData,
        } = this.state;
        const tableView = (row) => {
            if (row.invoices.length > 0) {
                return <div className="max-h-100">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell className="hCell">Due Date</TableCell>
                                <TableCell className="hCell">Invoice number</TableCell>
                                <TableCell className="hCell">Case number</TableCell>
                                <TableCell className="hCell">Matter name</TableCell>
                                <TableCell className="hCell">Payer</TableCell>
                                <TableCell className="hCell">Legal fees</TableCell>
                                <TableCell className="hCell">Third-party fees</TableCell>
                                <TableCell className="hCell">Discount</TableCell>
                                <TableCell className="hCell">Received payment</TableCell>
                                <TableCell className="hCell">Charge from deposite</TableCell>
                                <TableCell className="hCell">Gross profit</TableCell>
                                <TableCell className="hCell">Reallized profit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {row.invoices.map(obj => (
                                <TableRow key={obj.number} role="checkbox">
                                    <TableCell className="bCell">{timeFormat(obj.due_time)}</TableCell>
                                    <TableCell className="bCell">{obj.number}</TableCell>
                                    <TableCell className="bCell">{obj.case_number}</TableCell>
                                    <TableCell className="bCell">{obj.matter_name}</TableCell>
                                    <TableCell className="bCell">{obj.payer}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.legal_fees)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.third_party_fees)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.discount)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.payment)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.deposite)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.profit)}</TableCell>
                                    <TableCell className="bCell">${toMoney(obj.realized_profit)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            } else {
                return <div className="noTeams c">No Data</div>
            }
        }
        return (
            <Root>
                <div className="tableHead h">
                    <div className="f">Department</div>
                    <div className="f">Legal fees</div>
                    <div className="f">Third-party fees</div>
                    <div className="f">Discount</div>
                    <div className="f">Received payment</div>
                    <div className="f">Charge from deposite</div>
                    <div className="f">Gross profit</div>
                    <div className="f">Reallized profit</div>
                </div>
                {revenuesData.map((row, index) => (
                    <div key={index}>
                        <div className={row.expanded ? "expandBtn h" : "closeBtn h"} onClick={e => this.handleClickItem(e, index)}>
                            <ExpandMore className={row.expanded ? "iconExpand" : "iconClose"} />
                            <div className="f h">
                                <div className="f">{row.name}</div>
                                <div className="f">${toMoney(row.total.legal_fees)}</div>
                                <div className="f">${toMoney(row.total.third_party_fees)}</div>
                                <div className="f">${toMoney(row.total.discount)}</div>
                                <div className="f">${toMoney(row.total.payment)}</div>
                                <div className="f">${toMoney(row.total.deposite)}</div>
                                <div className="f">${toMoney(row.total.profit)}</div>
                                <div className="f">${toMoney(row.total.realized_profit)}</div>
                            </div>
                        </div>
                        <Collapse className="extend" in={row.expanded} timeout="auto" unmountOnExit>
                            {tableView(row)}
                        </Collapse>
                    </div>
                ))}
            </Root>
        )
    }
    componentDidMount() {
        const { revenuesData } = this.props;
        this.setState(() => ({
            revenuesData
        }));
    }
    componentDidUpdate(prevProps) {
        if (this.props.revenuesData !== prevProps.revenuesData) {
            const revenuesData = this.props.revenuesData;
            if (revenuesData) {
                console.log("revenuesData", revenuesData);
                this.setState(() => ({
                    revenuesData
                }));
            }
        }
    }
    handleClickItem(e, index) {
        const [...revenuesData] = this.state.revenuesData;
        const expanded = revenuesData[index].expanded
        revenuesData[index].expanded = !expanded;
        this.setState(() => ({
            revenuesData
        }));
    }
}

export default RevenueTable;